import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, CheckCircle2, ChevronLeft, ChevronRight, Eye, EyeOff, X } from 'lucide-react';
import { Link } from 'react-router-dom';
// Movie database for random selection (simulating AI)
const popularMovies = ['The Shawshank Redemption', 'The Godfather', 'The Dark Knight', 'Pulp Fiction', 'Forrest Gump', 'Inception', 'The Matrix', 'Goodfellas', 'The Lord of the Rings', 'Fight Club', 'Star Wars', 'Interstellar', 'The Lion King', 'Back to the Future', 'The Prestige', 'Gladiator', 'The Departed', 'The Usual Suspects', 'Se7en', 'The Silence of the Lambs', 'Saving Private Ryan', 'The Green Mile', 'Jurassic Park', 'Titanic', 'The Truman Show', 'Eternal Sunshine', 'Whiplash', 'La La Land'];
const SparkCard = () => {
  const [isRevealed, setIsRevealed] = useState(false);
  const [movie, setMovie] = useState('');
  useEffect(() => {
    // Generate unique movie for this visitor
    const randomMovie = popularMovies[Math.floor(Math.random() * popularMovies.length)];
    setMovie(randomMovie);
  }, []);
  return <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100" data-id="element-54">
      <div className="flex items-center gap-3 mb-4" data-id="element-55">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-xl" data-id="element-56">
          👀
        </div>
        <div data-id="element-57">
          <div className="font-bold text-sm" data-id="element-58">Today's Spark</div>
          <div className="text-xs text-muted-foreground" data-id="element-59">2 min left</div>
        </div>
      </div>
      <p className="text-lg font-medium leading-tight mb-4" data-id="element-60">
        "What's a movie you've seen more than 10 times?"
      </p>
      <button onClick={() => setIsRevealed(!isRevealed)} className="w-full rounded-lg p-4 transition-all relative overflow-hidden" style={{
      backgroundColor: isRevealed ? '#1f2937' : '#000',
      minHeight: '60px'
    }} data-id="element-61">
        <AnimatePresence mode="wait" data-id="element-62">
          {isRevealed ? <motion.div key="revealed" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} className="text-white" data-id="element-63">
              <div className="font-bold text-lg mb-2" data-id="element-64">{movie}</div>
              <div className="flex items-center justify-center gap-2 text-sm text-gray-400" data-id="element-65">
                <EyeOff className="w-4 h-4" data-id="element-66" />
                <span data-id="element-67">Hide Answer</span>
              </div>
            </motion.div> : <motion.div key="hidden" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} className="text-white flex items-center justify-center gap-2" data-id="element-68">
              <Eye className="w-5 h-5" data-id="element-69" />
              <span className="font-bold" data-id="element-70">Tap to Reveal</span>
            </motion.div>}
        </AnimatePresence>
      </button>
    </div>;
};
const screens = [{
  id: 'today',
  title: 'Today',
  content: <div className="w-full h-full bg-white relative overflow-hidden flex flex-col" data-id="element-71">
        <div className="pt-10 px-6 pb-4 bg-gray-50 border-b" data-id="element-72">
          <div className="flex justify-between items-center" data-id="element-73">
            <span className="font-bold text-lg" data-id="element-74">Day 3/7</span>
            <span style={{
          color: '#ff6b6b'
        }} className="font-bold flex items-center gap-1" data-id="element-75">
              🔥 3
            </span>
          </div>
        </div>
        <div className="flex-1 p-4 relative" data-id="element-76">
          <SparkCard data-id="element-77" />
        </div>
        <div className="p-4 border-t bg-white" data-id="element-78">
          <div className="flex justify-around text-gray-400" data-id="element-79">
            <div className="w-8 h-8 rounded-full bg-gray-100" data-id="element-80"></div>
            <div className="w-8 h-8 rounded-full" style={{
          backgroundColor: '#ff6b6b'
        }} data-id="element-81"></div>
            <div className="w-8 h-8 rounded-full bg-gray-100" data-id="element-82"></div>
          </div>
        </div>
      </div>
}, {
  id: 'fling',
  title: 'The Fling',
  content: <div className="w-full h-full bg-white relative overflow-hidden flex flex-col" data-id="element-83">
        <div className="pt-10 px-6 pb-4 bg-gray-50 border-b" data-id="element-84">
          <div className="flex justify-center gap-6 text-sm" data-id="element-85">
            <button className="text-gray-400" data-id="element-86">Today</button>
            <button className="font-bold pb-2 border-b-2" style={{
          borderColor: '#ff6b6b',
          color: '#ff6b6b'
        }} data-id="element-87">
              Fling
            </button>
            <button className="text-gray-400" data-id="element-88">Recap</button>
          </div>
        </div>
        <div className="flex-1 p-6 overflow-y-auto" data-id="element-89">
          <h2 className="text-3xl font-bold mb-6" data-id="element-90">The Fling</h2>
          <div className="bg-pink-50 rounded-2xl p-6 mb-6" data-id="element-91">
            <div className="flex items-center gap-2 mb-3" data-id="element-92">
              <span className="text-2xl" data-id="element-93">💘</span>
              <span className="font-bold text-lg" data-id="element-94">Day 7 Complete! 🎉</span>
            </div>
            <p className="text-gray-600 mb-4" data-id="element-95">
              Time to decide what happens next. Choose privately.
            </p>
            <button className="w-full bg-black text-white rounded-full py-3 font-bold" data-id="element-96">
              Make Your Decision
            </button>
          </div>
          <div className="flex items-center gap-4 mb-6" data-id="element-97">
            <div className="w-12 h-12 rounded-full bg-gray-200" data-id="element-98"></div>
            <div data-id="element-99">
              <div className="font-bold" data-id="element-100">Jordan</div>
              <div className="text-sm text-gray-500" data-id="element-101">Started 7 days ago</div>
            </div>
          </div>
          <div className="mb-6" data-id="element-102">
            <div className="flex justify-between items-center mb-2" data-id="element-103">
              <span className="text-gray-600" data-id="element-104">Progress</span>
              <span style={{
            color: '#ff6b6b'
          }} className="font-bold" data-id="element-105">
                Day 7/7
              </span>
            </div>
            <div className="flex gap-2" data-id="element-106">
              {[...Array(7)].map((_, i) => <div key={i} className="h-2 flex-1 rounded-full" style={{
            backgroundColor: i < 7 ? '#ff6b6b' : '#e5e7eb'
          }} data-id="element-107"></div>)}
            </div>
          </div>
        </div>
      </div>
}, {
  id: 'recap',
  title: 'Recap',
  content: <div className="w-full h-full bg-white relative overflow-hidden flex flex-col" data-id="element-108">
        <div className="pt-10 px-6 pb-4 bg-gray-50 border-b" data-id="element-109">
          <div className="flex justify-center gap-6 text-sm" data-id="element-110">
            <button className="text-gray-400" data-id="element-111">Today</button>
            <button className="text-gray-400" data-id="element-112">Fling</button>
            <button className="font-bold pb-2 border-b-2" style={{
          borderColor: '#ff6b6b',
          color: '#ff6b6b'
        }} data-id="element-113">
              Recap
            </button>
          </div>
        </div>
        <div className="flex-1 p-6 overflow-y-auto" data-id="element-114">
          <h2 className="text-3xl font-bold mb-2" data-id="element-115">Recaps</h2>
          <p className="text-xs text-gray-500 uppercase tracking-wider mb-6" data-id="element-116">
            LATEST
          </p>
          <div className="bg-pink-50 rounded-2xl p-6" data-id="element-117">
            <div className="flex justify-between items-start mb-4" data-id="element-118">
              <div data-id="element-119">
                <div className="font-bold text-xl mb-1" data-id="element-120">FlingLink</div>
                <div className="text-sm text-gray-500" data-id="element-121">7-Day Recap</div>
              </div>
              <div className="text-3xl" data-id="element-122">💕</div>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-123">
              <div data-id="element-124">
                <div className="text-xs text-gray-500 mb-1 flex items-center gap-1" data-id="element-125">
                  <span data-id="element-126">📅</span> Duration
                </div>
                <div className="font-bold" data-id="element-127">7 Days ✅</div>
              </div>
              <div data-id="element-128">
                <div className="text-xs text-gray-500 mb-1 flex items-center gap-1" data-id="element-129">
                  <span data-id="element-130">🔥</span> Streak
                </div>
                <div className="font-bold" data-id="element-131">7/7 🔥</div>
              </div>
              <div data-id="element-132">
                <div className="text-xs text-gray-500 mb-1 flex items-center gap-1" data-id="element-133">
                  <span data-id="element-134">🎯</span> Vibe
                </div>
                <div className="font-bold" data-id="element-135">Chill 😌</div>
              </div>
              <div data-id="element-136">
                <div className="text-xs text-gray-500 mb-1 flex items-center gap-1" data-id="element-137">
                  <span data-id="element-138">💘</span> Result
                </div>
                <div className="font-bold" data-id="element-139">Graduated</div>
              </div>
            </div>
            <div className="mb-4" data-id="element-140">
              <div className="text-xs text-gray-500 mb-2" data-id="element-141">Boundaries</div>
              <div className="flex gap-2 flex-wrap" data-id="element-142">
                <span className="text-sm bg-white px-3 py-1 rounded-full" data-id="element-143">
                  No overthinking 🧠🚫
                </span>
                <span className="text-sm bg-white px-3 py-1 rounded-full" data-id="element-144">
                  Keep it private 🤫
                </span>
              </div>
            </div>
            <div className="text-center pt-4 border-t" data-id="element-145">
              <div className="text-sm text-gray-600 mb-2" data-id="element-146">Alex & Jordan</div>
              <button style={{
            color: '#ff6b6b'
          }} className="text-sm font-bold flex items-center justify-center gap-1 mx-auto" data-id="element-147">
                Get your FlingLink →
              </button>
            </div>
          </div>
        </div>
      </div>
}];
export function Hero() {
  const [currentScreen, setCurrentScreen] = useState(0);
  const nextScreen = () => {
    setCurrentScreen(prev => (prev + 1) % screens.length);
  };
  const prevScreen = () => {
    setCurrentScreen(prev => (prev - 1 + screens.length) % screens.length);
  };
  return <section className="relative pt-8 pb-16 md:pt-20 md:pb-32 overflow-hidden" data-id="element-148">
      <div className="container mx-auto px-4" data-id="element-149">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-150">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left z-10" data-id="element-151">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-152">
              <Badge variant="accent" className="mb-6" style={{
              backgroundColor: '#ffe5e5',
              color: '#ff6b6b'
            }} data-id="element-153">
                UK Launch (for now) 🇬🇧
              </Badge>

              <h1 className="text-5xl md:text-7xl font-bold tracking-tighter leading-[1.1] mb-6" data-id="element-154">
                Send a link.
                <br data-id="element-155" />
                <span style={{
                color: '#ff6b6b'
              }} data-id="element-156">
                  Start a fling.
                </span>
              </h1>

              <p className="text-xl md:text-2xl text-muted-foreground mb-8 max-w-lg mx-auto md:mx-0 leading-relaxed" data-id="element-157">
                Set a vibe + boundaries. Do 2 minutes a day. Decide on Day 7.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-4 justify-center md:justify-start mb-8" data-id="element-158">
                <a href="https://me.flinglink.app/signup" className="w-full sm:w-auto" data-id="element-159">
                  <Button size="lg" className="w-full text-lg px-8" style={{
                  backgroundColor: '#ff6b6b'
                }} data-id="element-160">
                    Get Your FlingLink <ArrowRight className="ml-2 w-5 h-5" data-id="element-161" />
                  </Button>
                </a>
                <Link to="/how-it-works" data-id="element-162">
                  <Button variant="tertiary" className="text-muted-foreground" data-id="element-163">
                    Watch how it works
                  </Button>
                </Link>
              </div>

              <div className="flex items-center justify-center md:justify-start gap-6 text-sm text-muted-foreground font-medium" data-id="element-164">
                <span className="flex items-center gap-1" data-id="element-165">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-166" /> No swiping
                </span>
                <span className="flex items-center gap-1" data-id="element-167">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-168" /> No feed
                </span>
                <span className="flex items-center gap-1" data-id="element-169">
                  <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-170" /> No awkward
                  talks
                </span>
              </div>
            </motion.div>
          </div>

          {/* Phone Mockup with Swipeable Screens */}
          <div className="flex-1 w-full max-w-[400px] md:max-w-none relative" data-id="element-171">
            <div className="relative mx-auto w-[280px] md:w-[320px] h-[580px] bg-gray-900 rounded-[3rem] border-[8px] border-gray-900 shadow-2xl overflow-hidden" data-id="element-172">
              {/* Notch */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-gray-900 rounded-b-2xl z-20" data-id="element-173"></div>

              {/* Screen Content with Animation */}
              <AnimatePresence mode="wait" data-id="element-174">
                <motion.div key={currentScreen} initial={{
                opacity: 0,
                x: 100
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: -100
              }} transition={{
                duration: 0.3
              }} className="w-full h-full" data-id="element-175">
                  {screens[currentScreen].content}
                </motion.div>
              </AnimatePresence>

              {/* Navigation Arrows */}
              <button onClick={prevScreen} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white z-30 hover:bg-black/70 transition-colors" aria-label="Previous screen" data-id="element-176">
                <ChevronLeft className="w-5 h-5" data-id="element-177" />
              </button>
              <button onClick={nextScreen} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center text-white z-30 hover:bg-black/70 transition-colors" aria-label="Next screen" data-id="element-178">
                <ChevronRight className="w-5 h-5" data-id="element-179" />
              </button>

              {/* Dots Indicator */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-30" data-id="element-180">
                {screens.map((_, index) => <button key={index} onClick={() => setCurrentScreen(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentScreen ? 'w-6' : 'w-2'}`} style={{
                backgroundColor: index === currentScreen ? '#ff6b6b' : '#d1d5db'
              }} aria-label={`Go to screen ${index + 1}`} data-id="element-181" />)}
              </div>
            </div>

            {/* Floating Elements */}
            <motion.div animate={{
            y: [0, 15, 0]
          }} transition={{
            repeat: Infinity,
            duration: 3,
            ease: 'easeInOut'
          }} className="absolute top-20 -left-4 md:-left-12 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 max-w-[200px]" data-id="element-182">
              <div className="flex items-center gap-2 mb-2" data-id="element-183">
                <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-184"></div>
                <span className="text-xs font-bold text-gray-500" data-id="element-185">
                  INVITE SENT
                </span>
              </div>
              <p className="text-sm font-medium" data-id="element-186">
                "Hey, let's try this 7-day thing. Low pressure."
              </p>
            </motion.div>

            <motion.div animate={{
            y: [0, -15, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute bottom-32 -right-4 md:-right-8 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 max-w-[180px]" data-id="element-187">
              <div className="flex items-center gap-2 mb-2" data-id="element-188">
                <div className="w-2 h-2 rounded-full" style={{
                backgroundColor: '#ff6b6b'
              }} data-id="element-189"></div>
                <span className="text-xs font-bold text-gray-500" data-id="element-190">
                  STREAK SAVED
                </span>
              </div>
              <p className="text-sm font-medium" data-id="element-191">Grace save used! 🔥</p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}